"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props, state) {
  var _theme = theme,
      palette = _theme.palette,
      error = props.error,
      disabled = props.disabled,
      readOnly = props.readOnly,
      active = state.active,
      hover = state.hover;
  theme = _objectSpread({}, theme, {
    color: theme.hoverColor,
    placeholder: theme.idlePlaceholder,
    appearanceOpacity: theme.idleAppearanceOpacity
  });

  if (hover) {
    theme = _objectSpread({}, theme, {
      color: theme.hoverColor,
      placeholder: theme.hoverPlaceholder,
      appearanceOpacity: theme.hoverAppearanceOpacity
    });
  }

  if (active) {
    theme = _objectSpread({}, theme, {
      color: theme.focusColor,
      placeholder: theme.focusPlaceholder,
      appearanceOpacity: theme.focusAppearanceOpacity
    });
  }

  if (error) {
    theme = _objectSpread({}, theme, {
      color: theme.errorColor,
      placeholder: theme.errorPlaceholder
    });
  }

  if (disabled || readOnly) {
    theme = _objectSpread({}, theme, {
      color: theme.disabledColor,
      placeholder: theme.disabledPlaceholder,
      appearanceOpacity: theme.disabledAppearanceOpacity
    });
  }

  return {
    wrapper: {
      textAlign: 'left',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    field: {
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      color: theme.color,
      width: '100%',
      whiteSpace: 'nowrap',
      fontFamily: theme.fontFamily,
      paddingBottom: theme.paddingBottom,
      paddingTop: theme.paddingTop,
      paddingRight: theme.paddingRight,
      paddingLeft: theme.paddingLeft,
      flex: 2,
      margin: 0,
      border: '0 none',
      background: 'transparent',
      outline: '0 none',
      '&::placeholder': {
        color: theme.placeholder,
        transitionDuration: palette.transitionDuration,
        transitionTimingFunction: palette.transitionFunction,
        transitionProperty: 'color'
      }
    },
    iconWrapper: {
      opacity: theme.appearanceOpacity,
      transitionProperty: 'transform, opacity',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transform: active ? 'rotate(180deg)' : 'none',
      flex: 0,
      flexShrink: 0,
      display: 'flex'
    },
    icon: {
      width: palette.gutter * 3 + 'px',
      height: palette.gutter * 3 + 'px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      transitionProperty: 'background, background-image',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction
    }
  };
}